var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"tr-pill",class:`tr-pill-${_vm.status}`},[(_vm.icon)?_c('fa-icon',{attrs:{"icon":['fal', _vm.icon]}}):_vm._e(),_vm._v(_vm._s(_vm.label)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }